// store.js
import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice"; // Assuming you'll create a slice for user-related actions

export default configureStore({
  reducer: {
    user: userReducer,
    // You can add more reducers here for other parts of your application
  },
});
